<!-- src/views/PagoServicio.vue -->
<template>
  <div class="p-4">
    <!-- Encabezado -->
    <div class="mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h2 class="text-2xl font-bold text-gray-800 dark:text-white">
          Pagos del Día
        </h2>
        <p class="text-gray-600 dark:text-gray-400">
          {{ tituloPeriodo }}
        </p>
      </div>
      <div class="flex gap-2 flex-wrap">
        <button
          @click="descargarReporte"
          class="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors flex items-center gap-2 text-sm"
          :disabled="pagosFiltrados.length === 0 || loading"
        >
          <Icon icon="mdi:file-pdf-box" width="18" height="18" />
          PDF
        </button>
      </div>
    </div>

    <!-- BARRA DE CALENDARIO -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-700 p-3 sm:p-4 mb-6">
      <!-- Selector de vista -->
      <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-4">
        <div class="flex items-center gap-2">
          <div class="w-8 h-1 bg-indigo-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-indigo-600 tracking-widest uppercase">Calendario</span>
        </div>

        <div class="flex gap-1 p-1 bg-gray-100 dark:bg-gray-900 rounded-xl w-full sm:w-auto">
          <button
            v-for="v in vistasDisponibles"
            :key="v.key"
            @click="cambiarVista(v.key)"
            :class="[
              'flex-1 sm:flex-none px-3 py-1.5 text-[10px] sm:text-xs font-black uppercase rounded-lg transition-all whitespace-nowrap',
              vistaActual === v.key
                ? 'bg-white dark:bg-gray-700 text-indigo-600 dark:text-indigo-300 shadow-sm'
                : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
            ]"
          >
            <Icon :icon="v.icon" class="inline mr-1 text-sm" />
            {{ v.label }}
          </button>
        </div>
      </div>

      <!-- Vista DÍA -->
      <div v-if="vistaActual === 'dia'" class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <div class="relative w-full sm:w-auto">
          <div class="flex items-center gap-2 px-3 sm:px-4 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl cursor-pointer hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm">
            <Icon icon="mdi:calendar-month" class="text-indigo-600 dark:text-indigo-400 text-lg flex-shrink-0" />
            <input
              type="date"
              v-model="fechaInput"
              @change="cambiarFechaDesdeInput"
              class="bg-transparent border-none outline-none text-sm font-medium text-gray-700 dark:text-gray-300 w-[140px] sm:w-[160px] cursor-pointer"
              :max="fechaMaxima"
            />
          </div>
        </div>

        <div class="flex gap-1 w-full sm:w-auto">
          <button @click="navegar(-1)" class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm" title="Día anterior">
            <Icon icon="mdi:chevron-left" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
          <button @click="resetearPeriodo" class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 dark:hover:bg-indigo-800/50 transition-all shadow-sm whitespace-nowrap">
            Hoy
          </button>
          <button @click="navegar(1)" class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm" title="Día siguiente" :disabled="esFechaHoy" :class="{ 'opacity-40 cursor-not-allowed': esFechaHoy }">
            <Icon icon="mdi:chevron-right" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
        </div>

        <button @click="recargarPagos" :disabled="loading" class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-lg shadow-indigo-500/20 flex items-center gap-2 w-full sm:w-auto justify-center disabled:opacity-50">
          <Icon icon="mdi:refresh" :class="{'animate-spin': loading}" class="text-base" />
          <span>Actualizar</span>
        </button>
      </div>

      <!-- Vista SEMANA -->
      <div v-else-if="vistaActual === 'semana'" class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <div class="flex items-center gap-3 px-4 py-2 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800/40 rounded-xl w-full sm:w-auto">
          <Icon icon="mdi:calendar-week" class="text-indigo-600 dark:text-indigo-400 text-xl" />
          <div class="flex flex-col">
            <span class="text-[9px] font-black text-indigo-500 dark:text-indigo-400 uppercase tracking-widest">Semana</span>
            <span class="text-xs font-black text-gray-700 dark:text-gray-200">{{ etiquetaSemana }}</span>
          </div>
        </div>

        <div class="flex gap-1 w-full sm:w-auto">
          <button @click="navegar(-1)" class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm" title="Semana anterior">
            <Icon icon="mdi:chevron-left" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
          <button @click="resetearPeriodo" class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 dark:hover:bg-indigo-800/50 transition-all shadow-sm whitespace-nowrap">
            Hoy
          </button>
          <button @click="navegar(1)" class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm" title="Semana siguiente">
            <Icon icon="mdi:chevron-right" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
        </div>

        <button @click="recargarPagos" :disabled="loading" class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-lg shadow-indigo-500/20 flex items-center gap-2 w-full sm:w-auto justify-center disabled:opacity-50">
          <Icon icon="mdi:refresh" :class="{'animate-spin': loading}" class="text-base" />
          <span>Actualizar</span>
        </button>
      </div>

      <!-- Vista MES -->
      <div v-else-if="vistaActual === 'mes'" class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <div class="flex items-center gap-3 px-4 py-2 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800/40 rounded-xl w-full sm:w-auto">
          <Icon icon="mdi:calendar-month-outline" class="text-indigo-600 dark:text-indigo-400 text-xl" />
          <div class="flex flex-col">
            <span class="text-[9px] font-black text-indigo-500 dark:text-indigo-400 uppercase tracking-widest">Mes</span>
            <span class="text-xs font-black text-gray-700 dark:text-gray-200 capitalize">{{ etiquetaMes }}</span>
          </div>
        </div>

        <div class="flex gap-1 w-full sm:w-auto">
          <button @click="navegar(-1)" class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm" title="Mes anterior">
            <Icon icon="mdi:chevron-left" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
          <button @click="resetearPeriodo" class="px-2 sm:px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 dark:hover:bg-indigo-800/50 transition-all shadow-sm whitespace-nowrap">
            Hoy
          </button>
          <button @click="navegar(1)" class="p-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl hover:border-indigo-500 dark:hover:border-indigo-400 transition-all shadow-sm" title="Mes siguiente">
            <Icon icon="mdi:chevron-right" class="text-gray-600 dark:text-gray-400 text-base" />
          </button>
        </div>

        <button @click="recargarPagos" :disabled="loading" class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-lg shadow-indigo-500/20 flex items-center gap-2 w-full sm:w-auto justify-center disabled:opacity-50">
          <Icon icon="mdi:refresh" :class="{'animate-spin': loading}" class="text-base" />
          <span>Actualizar</span>
        </button>
      </div>

      <!-- Vista RANGO -->
      <div v-else-if="vistaActual === 'rango'" class="flex flex-col gap-3">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-3 shadow-sm">
            <div class="flex items-center gap-2 mb-2">
              <div class="p-1.5 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg">
                <Icon icon="mdi:calendar-arrow-right" class="text-emerald-600 dark:text-emerald-400 text-sm" />
              </div>
              <span class="text-[9px] font-black text-emerald-600 dark:text-emerald-400 uppercase tracking-widest">Desde</span>
            </div>
            <input
              type="date"
              v-model="rangoDesde"
              @change="validarRango"
              class="w-full bg-transparent border-none outline-none text-sm font-bold text-gray-700 dark:text-gray-300 cursor-pointer"
              :max="rangoHasta || fechaMaxima"
            />
          </div>

          <div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-3 shadow-sm">
            <div class="flex items-center gap-2 mb-2">
              <div class="p-1.5 bg-rose-100 dark:bg-rose-900/30 rounded-lg">
                <Icon icon="mdi:calendar-arrow-left" class="text-rose-600 dark:text-rose-400 text-sm" />
              </div>
              <span class="text-[9px] font-black text-rose-600 dark:text-rose-400 uppercase tracking-widest">Hasta</span>
            </div>
            <input
              type="date"
              v-model="rangoHasta"
              @change="validarRango"
              class="w-full bg-transparent border-none outline-none text-sm font-bold text-gray-700 dark:text-gray-300 cursor-pointer"
              :min="rangoDesde"
              :max="fechaMaxima"
            />
          </div>
        </div>

        <div class="flex flex-wrap gap-2">
          <button @click="resetearPeriodo" class="px-3 py-2 bg-indigo-100 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-300 rounded-xl text-xs font-bold hover:bg-indigo-200 dark:hover:bg-indigo-800/50 transition-all shadow-sm whitespace-nowrap">
            <Icon icon="mdi:calendar-today" class="inline mr-1" /> Este mes
          </button>
          <button @click="setRangoUltimos7Dias" class="px-3 py-2 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl text-xs font-bold hover:bg-gray-200 dark:hover:bg-gray-600 transition-all shadow-sm whitespace-nowrap">
            <Icon icon="mdi:calendar-range" class="inline mr-1" /> Últimos 7 días
          </button>
          <button @click="setRangoUltimos30Dias" class="px-3 py-2 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl text-xs font-bold hover:bg-gray-200 dark:hover:bg-gray-600 transition-all shadow-sm whitespace-nowrap">
            <Icon icon="mdi:calendar-range" class="inline mr-1" /> Últimos 30 días
          </button>
          <button @click="recargarPagos" :disabled="loading" class="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-black text-[10px] sm:text-xs tracking-widest transition-all shadow-lg shadow-indigo-500/20 flex items-center gap-2 disabled:opacity-50 ml-auto">
            <Icon icon="mdi:refresh" :class="{'animate-spin': loading}" class="text-base" />
            <span>Actualizar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Resumen -->
    <div class="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-6">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-3 md:p-4">
        <div class="text-xs md:text-sm text-gray-500 dark:text-gray-400">Total Pagos</div>
        <div class="text-xl md:text-2xl font-bold text-gray-900 dark:text-white">{{ pagosFiltrados.length }}</div>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-3 md:p-4">
        <div class="text-xs md:text-sm text-gray-500 dark:text-gray-400">Monto US$</div>
        <div class="text-xl md:text-2xl font-bold text-green-600 dark:text-green-400">{{ formatoMoneda(totalMontoFiltrado) }}</div>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-3 md:p-4 col-span-2 md:col-span-1">
        <div class="text-xs md:text-sm text-gray-500 dark:text-gray-400">Monto Bs</div>
        <div class="text-xl md:text-2xl font-bold text-blue-600 dark:text-blue-400">{{ formatoMonedaBs(totalMontoBsFiltrado) }}</div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 md:p-6 mb-6">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Orden</label>
          <input v-model="filters.numeroOrden" type="text" class="w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm" placeholder="Ej: 6590" @keyup.enter="filtrarPagos" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Cliente</label>
          <input v-model="filters.cliente" type="text" class="w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm" placeholder="Nombre" @keyup.enter="filtrarPagos" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Método Pago</label>
          <select v-model="filters.metodoPago" class="w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm">
            <option value="">Todos</option>
            <option value="Efectivo">Efectivo</option>
            <option value="Punto de Venta">Punto de Venta</option>
            <option value="Pago Móvil">Pago Móvil</option>
            <option value="Transferencia">Transferencia</option>
            <option value="Depósito">Depósito</option>
            <option value="Tarjeta de Crédito">Tarjeta de Crédito</option>
            <option value="CREDITO CACHEAS">Crédito Cacheas</option>
            <option value="CREDITO EMPRESA">Crédito Empresa</option>
            <option value="CREDITO EMPRESARIAL">Crédito Empresarial</option>
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo Crédito</label>
          <select v-model="filters.tipoCredito" class="w-full rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white shadow-sm focus:border-blue-500 focus:ring-blue-500 text-sm">
            <option value="">Todos</option>
            <option value="CACHEAS">Cachéas</option>
            <option value="EMPRESA">Empresa</option>
            <option value="EMPRESARIAL">Empresarial</option>
          </select>
        </div>
      </div>
      <div class="mt-4 flex flex-wrap gap-2 md:gap-3">
        <button @click="filtrarPagos" class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center gap-2 text-sm">
          <Icon icon="mdi:filter" width="18" height="18" />
          Filtrar
        </button>
        <button @click="limpiarFiltros" class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors text-sm">
          Limpiar
        </button>
      </div>
    </div>

    <!-- Tabla de Pagos - Desktop -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden hidden md:block">
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead class="bg-gray-50 dark:bg-gray-700">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Orden</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Cliente</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Fecha/Hora Pago</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">US$</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Bs</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Método</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Tipo Crédito</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Referencia</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Registrado</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            <tr v-if="loading">
              <td colspan="10" class="px-4 py-4 text-center text-gray-500 dark:text-gray-400">
                <div class="flex justify-center items-center">
                  <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                  <span class="ml-2">Cargando pagos...</span>
                </div>
              </td>
            </tr>
            <tr v-else-if="pagosFiltrados.length === 0">
              <td colspan="10" class="px-4 py-4 text-center text-gray-500 dark:text-gray-400">No hay pagos registrados</td>
            </tr>
            <tr v-for="pago in pagosFiltrados" :key="pago.idPagoSalidaEquipo" class="hover:bg-gray-50 dark:hover:bg-gray-700">
              <td class="px-4 py-3 whitespace-nowrap text-sm">
                <button @click="verDetallesEquipo(pago)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium hover:underline transition-colors cursor-pointer" title="Ver detalles de la orden">
                  {{ pago.numeroOrden }}
                </button>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">{{ pago.nombreCliente || 'Sin cliente' }}</td>
              <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                <div class="flex flex-col">
                  <span>{{ formatoFecha(pago.fechaPago, true) }}</span>
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-white">{{ formatoMoneda(pago.montoUsd) }}</td>
              <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">{{ formatoMonedaBs(pago.montoBs) }}</td>
              <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                <span :class="metodoPagoClass(pago.metodoPago)" class="px-2 py-1 text-xs font-semibold rounded-full">{{ pago.metodoPago }}</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                <span v-if="pago.tipoCredito" :class="tipoCreditoClass(pago.tipoCredito)" class="px-2 py-1 text-xs font-semibold rounded-full">{{ pago.tipoCredito }}</span>
                <span v-else class="text-gray-400 text-xs">N/A</span>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">{{ pago.referencia || 'S/R' }}</td>
              <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                <div class="flex flex-col">
                  <span class="text-xs">{{ formatoFecha(pago.fechaRegistro || pago.createdAt || pago.fechaCreacion, true) || 'N/A' }}</span>
                  <span class="text-xs text-gray-500 dark:text-gray-400">{{ pago.usuarioRegistro || pago.usuarioCreacion || pago.registradoPor || 'N/A' }}</span>
                </div>
              </td>
              <td class="px-4 py-3 whitespace-nowrap text-sm">
                <button @click="verDetallesEquipo(pago)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors p-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/20" title="Ver detalles del equipo">
                  <Icon icon="mdi:information-outline" width="20" height="20" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación Desktop -->
      <div class="px-4 py-3 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between">
        <div class="text-sm text-gray-700 dark:text-gray-300">
          Mostrando {{ (pagination.currentPage - 1) * pagination.perPage + 1 }} - 
          {{ Math.min(pagination.currentPage * pagination.perPage, pagination.total) }} de {{ pagination.total }}
        </div>
        <div class="flex gap-2">
          <button @click="cambiarPagina(pagination.currentPage - 1)" :disabled="pagination.currentPage === 1" class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-sm">Anterior</button>
          <button @click="cambiarPagina(pagination.currentPage + 1)" :disabled="pagination.currentPage >= pagination.lastPage" class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-sm">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- Tarjetas de Pagos - Mobile -->
    <div class="md:hidden space-y-3">
      <div v-if="loading" class="text-center py-8 text-gray-500 dark:text-gray-400">
        <div class="flex justify-center items-center">
          <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span class="ml-2">Cargando...</span>
        </div>
      </div>
      <div v-else-if="pagosFiltrados.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">No hay pagos registrados</div>
      <div v-for="pago in pagosFiltrados" :key="pago.idPagoSalidaEquipo" class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4">
        <div class="flex justify-between items-start mb-2">
          <span :class="tipoPagoClass(pago.tipoPago)" class="px-2 py-1 text-xs font-semibold rounded-full">{{ pago.tipoPago }}</span>
          <button @click="verDetallesEquipo(pago)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition-colors p-1 rounded hover:bg-blue-50 dark:hover:bg-blue-900/20" title="Ver detalles del equipo">
            <Icon icon="mdi:information-outline" width="20" height="20" />
          </button>
        </div>
        
        <div class="grid grid-cols-2 gap-2 text-sm">
          <div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Orden</span>
            <button @click="verDetallesEquipo(pago)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 font-medium hover:underline cursor-pointer block text-left">{{ pago.numeroOrden }}</button>
          </div>
          <div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Cliente</span>
            <p class="text-gray-900 dark:text-white truncate">{{ pago.nombreCliente || 'Sin cliente' }}</p>
          </div>
          <div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Fecha/Hora</span>
            <p class="text-gray-900 dark:text-white">{{ formatoFecha(pago.fechaPago, true) }}</p>
          </div>
          <div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Método</span>
            <p><span :class="metodoPagoClass(pago.metodoPago)" class="px-2 py-0.5 text-xs font-semibold rounded-full">{{ pago.metodoPago }}</span></p>
          </div>
          <div>
            <span class="text-xs text-gray-500 dark:text-gray-400">US$</span>
            <p class="font-medium text-gray-900 dark:text-white">{{ formatoMoneda(pago.montoUsd) }}</p>
          </div>
          <div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Bs</span>
            <p class="text-gray-900 dark:text-white">{{ formatoMonedaBs(pago.montoBs) }}</p>
          </div>
          <div class="col-span-2">
            <span class="text-xs text-gray-500 dark:text-gray-400">Tipo Crédito</span>
            <p>
              <span v-if="pago.tipoCredito" :class="tipoCreditoClass(pago.tipoCredito)" class="px-2 py-0.5 text-xs font-semibold rounded-full">{{ pago.tipoCredito }}</span>
              <span v-else class="text-gray-400 text-xs">N/A</span>
            </p>
          </div>
          <div class="col-span-2">
            <span class="text-xs text-gray-500 dark:text-gray-400">Referencia</span>
            <p class="text-gray-900 dark:text-white">{{ pago.referencia || 'S/R' }}</p>
          </div>
        </div>
      </div>

      <!-- Paginación Mobile -->
      <div class="flex items-center justify-between mt-4">
        <div class="text-xs text-gray-700 dark:text-gray-300">
          {{ (pagination.currentPage - 1) * pagination.perPage + 1 }} - 
          {{ Math.min(pagination.currentPage * pagination.perPage, pagination.total) }} de {{ pagination.total }}
        </div>
        <div class="flex gap-2">
          <button @click="cambiarPagina(pagination.currentPage - 1)" :disabled="pagination.currentPage === 1" class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-sm">Anterior</button>
          <button @click="cambiarPagina(pagination.currentPage + 1)" :disabled="pagination.currentPage >= pagination.lastPage" class="px-3 py-1 border border-gray-300 dark:border-gray-600 rounded-md disabled:opacity-50 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-sm">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- MODAL DE DETALLES (5 pestañas) -->
    <!-- ============================================ -->
    <Teleport to="body">
      <div v-if="showModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[9997]" @click.self="cerrarModal">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-3xl flex flex-col overflow-hidden animate-zoomIn max-h-[92vh]">
          <!-- Header -->
          <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 sm:px-5 py-2.5 sm:py-3 flex items-center justify-between flex-shrink-0">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 bg-white/20 rounded-lg">
                <Icon icon="mdi:receipt-text" class="text-white text-base sm:text-lg" />
              </div>
              <div>
                <h3 class="text-xs sm:text-sm font-bold text-white uppercase tracking-wider">#{{ ordenDetalles?.numeroOrden || 'Cargando...' }}</h3>
                <p class="text-[8px] sm:text-[9px] text-blue-100 font-bold">{{ formatFechaCompleta(ordenDetalles?.fechaIngreso || ordenDetalles?.fechaPago) }}</p>
              </div>
            </div>
            <button @click="cerrarModal" class="p-1 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-base sm:text-lg" />
            </button>
          </div>

          <!-- Tabs -->
          <div class="flex bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700 p-1 flex-shrink-0 overflow-x-auto">
            <button 
              v-for="tab in tabsDisponibles" 
              :key="tab.key" 
              @click="tabActiva = tab.key" 
              :class="['flex-1 min-w-[70px] py-1.5 text-[8px] sm:text-[9px] font-black uppercase rounded-lg transition-all whitespace-nowrap', tabActiva === tab.key ? 'bg-white dark:bg-gray-700 text-blue-600 shadow-sm' : 'text-gray-400 hover:text-gray-600']"
            >
              {{ tab.label }}
            </button>
          </div>

          <!-- Content -->
          <div class="flex-1 overflow-y-auto p-3 sm:p-4 custom-scrollbar">
            <div v-if="loadingDetalles" class="text-center py-12">
              <div class="inline-block animate-spin rounded-full h-10 w-10 border-4 border-blue-500 border-t-transparent"></div>
              <p class="mt-3 text-gray-600 dark:text-gray-400 font-medium text-sm">Cargando detalles...</p>
            </div>

            <template v-else-if="ordenDetalles">
              <!-- TAB RESUMEN -->
              <div v-if="tabActiva === 'resumen'" class="space-y-2.5 sm:space-y-3 animate-fadeIn">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                  <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Cliente</span>
                    <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ ordenDetalles.cliente?.nombre || 'Sin cliente' }}</span>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Documento / Teléfono</span>
                    <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ ordenDetalles.cliente?.documento || 'N/A' }} · {{ ordenDetalles.cliente?.telefono || 'N/A' }}</span>
                  </div>
                </div>
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-1.5 sm:gap-2">
                  <div class="p-2 bg-blue-500/5 rounded-lg text-center">
                    <p class="text-[7px] sm:text-[8px] font-bold text-blue-400 uppercase mb-0.5">Total USD</p>
                    <p class="text-[10px] sm:text-xs font-black text-blue-600">{{ formatoMoneda(ordenDetalles.montoDolares || 0) }}</p>
                  </div>
                  <div class="p-2 bg-green-500/5 rounded-lg text-center">
                    <p class="text-[7px] sm:text-[8px] font-bold text-green-400 uppercase mb-0.5">Estado</p>
                    <p class="text-[8px] sm:text-[9px] font-black text-green-600 uppercase">{{ ordenDetalles.estado || 'N/A' }}</p>
                  </div>
                  <div class="p-2 bg-amber-500/5 rounded-lg text-center">
                    <p class="text-[7px] sm:text-[8px] font-bold text-amber-400 uppercase mb-0.5">Total Bs</p>
                    <p class="text-[10px] sm:text-xs font-black text-amber-600">{{ formatoMonedaBs(ordenDetalles.montoBolivares || 0) }}</p>
                  </div>
                  <div class="p-2 bg-purple-500/5 rounded-lg text-center">
                    <p class="text-[7px] sm:text-[8px] font-bold text-purple-400 uppercase mb-0.5">Tasa</p>
                    <p class="text-[10px] sm:text-xs font-black text-purple-600">Bs {{ ordenDetalles.tasa?.valor || 'N/A' }}</p>
                  </div>
                </div>
                <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-1">Fechas</span>
                  <div class="grid grid-cols-2 gap-2 text-[10px] sm:text-xs">
                    <div>
                      <span class="text-gray-500 dark:text-gray-400">Ingreso:</span>
                      <p class="font-bold text-gray-800 dark:text-white">{{ formatoFecha(ordenDetalles.fechaIngreso, true) }}</p>
                    </div>
                    <div>
                      <span class="text-gray-500 dark:text-gray-400">Entrega:</span>
                      <p class="font-bold text-gray-800 dark:text-white">{{ ordenDetalles.fechaEntrega ? formatoFecha(ordenDetalles.fechaEntrega, true) : 'Pendiente' }}</p>
                    </div>
                  </div>
                </div>
                <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                  <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-1">Registro</span>
                  <p class="text-[10px] sm:text-xs text-gray-800 dark:text-white font-bold">{{ formatoFecha(ordenDetalles.fechaRegistro, true) }}</p>
                  <p class="text-[8px] sm:text-[9px] text-gray-500 dark:text-gray-400">por {{ ordenDetalles.usuarioRegistro || 'N/A' }}</p>
                </div>
              </div>

              <!-- TAB EQUIPO -->
              <div v-if="tabActiva === 'equipo'" class="space-y-2.5 sm:space-y-3 animate-fadeIn">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                  <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Tipo de Equipo</span>
                    <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ ordenDetalles.equipo || 'N/A' }}</span>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Clave / Patrón</span>
                    <span class="text-xs sm:text-sm font-black text-gray-800 dark:text-white">{{ ordenDetalles.clavePatron || 'N/A' }}</span>
                  </div>
                  <div class="sm:col-span-2 p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Descripción</span>
                    <span class="text-[10px] sm:text-xs text-gray-800 dark:text-white">{{ ordenDetalles.descripcionEquipo || 'N/A' }}</span>
                  </div>
                  <div class="sm:col-span-2 p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Accesorios</span>
                    <span class="text-[10px] sm:text-xs text-gray-800 dark:text-white">{{ ordenDetalles.accesorios || 'N/A' }}</span>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Sede</span>
                    <span class="text-[10px] sm:text-xs font-black text-gray-800 dark:text-white">{{ ordenDetalles.sede || 'N/A' }}</span>
                  </div>
                  <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase block mb-0.5">Técnicos</span>
                    <span class="text-[10px] sm:text-xs font-black text-gray-800 dark:text-white">Recibió: {{ ordenDetalles.tecnicoRecepcion || 'N/A' }}</span>
                    <p class="text-[9px] text-gray-500 dark:text-gray-400">Reparó: {{ ordenDetalles.tecnicoReparador || 'N/A' }}</p>
                  </div>
                </div>
                <div class="p-2.5 sm:p-3 bg-red-500/5 rounded-xl border border-red-100 dark:border-red-900/30">
                  <span class="text-[8px] sm:text-[9px] font-bold text-red-500 uppercase block mb-0.5">Problema Reportado</span>
                  <span class="text-[10px] sm:text-xs text-gray-800 dark:text-white">{{ ordenDetalles.problema || 'No especificado' }}</span>
                </div>
              </div>

              <!-- TAB SERVICIOS -->
              <div v-if="tabActiva === 'servicios'" class="space-y-2.5 sm:space-y-3 animate-fadeIn">
                <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                  <div class="flex items-center gap-2 mb-1.5">
                    <Icon icon="mdi:stethoscope" class="text-yellow-500" width="16" height="16" />
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase">Diagnóstico</span>
                  </div>
                  <p class="text-[10px] sm:text-xs text-gray-800 dark:text-white">{{ ordenDetalles.diagnostico || 'No especificado' }}</p>
                </div>
                <div class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                  <div class="flex items-center gap-2 mb-1.5">
                    <Icon icon="mdi:tools" class="text-green-500" width="16" height="16" />
                    <span class="text-[8px] sm:text-[9px] font-bold text-gray-400 uppercase">Solución Aplicada</span>
                  </div>
                  <p class="text-[10px] sm:text-xs text-gray-800 dark:text-white">{{ ordenDetalles.solucion || 'No especificado' }}</p>
                </div>

                <div class="bg-white dark:bg-gray-800 rounded-xl shadow border border-gray-100 dark:border-gray-700 overflow-hidden">
                  <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 px-2.5 py-1.5 border-b border-gray-100 dark:border-gray-700">
                    <h2 class="text-[10px] sm:text-xs font-bold text-gray-800 dark:text-white flex items-center">
                      <div class="p-1 bg-green-100 dark:bg-green-900/30 rounded-lg mr-2">
                        <Icon icon="mdi:cash-multiple" class="text-green-600 dark:text-green-400 text-sm" />
                      </div>
                      Servicios y Productos Cobrados
                    </h2>
                  </div>
                  <div class="p-2.5 sm:p-3">
                    <div v-if="itemsDetalle.length === 0" class="py-4 text-center">
                      <Icon icon="mdi:package-variant-remove" class="text-3xl text-gray-300 mx-auto mb-2" />
                      <p class="text-[10px] text-gray-400">No hay servicios ni productos registrados</p>
                    </div>

                    <div v-if="itemsDetalle.length > 0" class="space-y-1.5">
                      <p class="text-[8px] font-black text-gray-400 uppercase tracking-wider mb-1">Servicios / Productos</p>
                      <div v-for="it in itemsDetalle" :key="it.uuid" class="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-900/50 rounded-lg border border-gray-100 dark:border-gray-700">
                        <div class="flex items-center gap-2 flex-1 min-w-0">
                          <div :class="it.tipo === 'servicio' ? 'bg-green-100 dark:bg-green-900/30 text-green-600' : (it.tipo === 'producto' ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600' : 'bg-orange-100 dark:bg-orange-900/30 text-orange-600')" class="p-1.5 rounded-lg shrink-0">
                            <Icon :icon="it.tipo === 'servicio' ? 'mdi:wrench' : (it.tipo === 'producto' ? 'mdi:package-variant' : 'mdi:tools')" class="text-xs" />
                          </div>
                          <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-2 flex-wrap">
                              <p class="text-[10px] font-bold text-gray-800 dark:text-white truncate uppercase">{{ it.nombre }}</p>
                              <span v-if="it.cantidad && it.cantidad > 1" class="text-[8px] font-black bg-gray-200 dark:bg-gray-700 px-1.5 py-0.5 rounded-full">x{{ it.cantidad }}</span>
                            </div>
                            <p class="text-[8px] text-gray-400 font-black uppercase tracking-widest">{{ it.tipo }} {{ it.cantidad && it.cantidad > 1 ? `( $${it.precio_unitario.toFixed(2)} c/u )` : '' }}</p>
                          </div>
                        </div>
                        <span class="text-[11px] font-black text-green-600 dark:text-green-400 ml-2">${{ (it.precio_total || 0).toFixed(2) }}</span>
                      </div>
                    </div>

                    <div v-if="itemsDetalle.length > 0" class="mt-2.5 pt-2.5 border-t border-gray-100 dark:border-gray-700">
                      <div class="flex justify-between items-center bg-green-50 dark:bg-green-900/20 px-2.5 py-2 rounded-lg border border-green-100 dark:border-green-800/40">
                        <span class="text-[9px] font-black text-green-700 dark:text-green-400 uppercase tracking-wider">TOTAL GENERAL:</span>
                        <span class="text-sm font-black text-green-600 dark:text-green-400">${{ totalGeneralDetalle.toFixed(2) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- TAB PAGOS -->
              <div v-if="tabActiva === 'pagos'" class="space-y-2.5 sm:space-y-3 animate-fadeIn">
                <div v-if="pagosDetalle.length === 0" class="text-center py-8">
                  <Icon icon="mdi:cash-off" class="text-4xl text-gray-300 mx-auto mb-2" />
                  <p class="text-[10px] text-gray-400 font-bold uppercase">No se registran pagos</p>
                </div>

                <div v-else class="space-y-2">
                  <div v-for="(pago, i) in pagosDetalle" :key="i" class="p-2.5 sm:p-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 shadow-sm">
                    <div class="flex justify-between items-center border-b border-gray-50 dark:border-gray-700 pb-1.5 mb-2">
                      <span class="text-[9px] sm:text-[10px] font-black text-indigo-500 uppercase">Recibo #{{ i+1 }}</span>
                      <span class="text-[8px] sm:text-[9px] font-bold text-gray-400">{{ formatoFecha(pago.fechaPago || pago.fechaRegistro, true) }}</span>
                    </div>
                    <div class="flex justify-between items-end">
                      <div class="min-w-0 flex-1 pr-2">
                        <p class="text-[9px] sm:text-[10px] font-bold text-gray-400 uppercase truncate">Vía: {{ pago.metodoPago || pago.tipoPago || 'Efectivo' }}</p>
                        <p v-if="pago.referencia" class="text-[8px] text-gray-400 truncate">Ref: {{ pago.referencia }}</p>
                        <p v-if="pago.usuarioRegistro" class="text-[8px] text-gray-400 truncate">Por: {{ pago.usuarioRegistro }}</p>
                      </div>
                      <div class="text-right shrink-0">
                        <p class="text-sm sm:text-base font-black text-green-600">{{ formatoMoneda(pago.montoUsd || 0) }}</p>
                        <p v-if="pago.montoBs > 0" class="text-[8px] text-gray-400">{{ formatoMonedaBs(pago.montoBs) }}</p>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 p-2.5 sm:p-3 rounded-xl bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border border-green-100 dark:border-green-800/40 flex justify-between items-center">
                    <span class="text-[10px] font-black text-green-700 dark:text-green-400 uppercase tracking-wider">TOTAL COBRADO:</span>
                    <span class="text-sm sm:text-base font-black text-green-600 dark:text-green-400">{{ formatoMoneda(totalPagadoDetalle) }}</span>
                  </div>
                </div>
              </div>

              <!-- TAB OBSERVACIONES -->
              <div v-if="tabActiva === 'observaciones'" class="p-2.5 sm:p-3 bg-gray-50 dark:bg-gray-800/50 rounded-xl min-h-[60px] border border-gray-100 dark:border-gray-700 animate-fadeIn">
                <p class="text-[10px] sm:text-xs text-gray-600 dark:text-gray-300">{{ ordenDetalles.observaciones || 'Sin comentarios adicionales.' }}</p>
                <div v-if="ordenDetalles.fechaModificacion" class="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
                  <span class="text-[8px] font-bold text-gray-400 uppercase">Modificado</span>
                  <p class="text-[9px] text-gray-600 dark:text-gray-300">{{ formatoFecha(ordenDetalles.fechaModificacion, true) }} por {{ ordenDetalles.usuarioModificacion || 'N/A' }}</p>
                </div>
              </div>
            </template>
          </div>

          <!-- Footer -->
          <div class="px-3 sm:px-4 py-2.5 sm:py-3 border-t border-gray-100 dark:border-gray-700 bg-gray-50/50 dark:bg-gray-800/50 flex flex-col sm:flex-row justify-end gap-2 flex-shrink-0">
            <button @click="cerrarModal" class="w-full sm:w-auto px-3 sm:px-4 py-1.5 text-[9px] sm:text-[10px] font-black text-gray-400 uppercase hover:text-gray-600 transition-colors">Cerrar</button>
            <button v-if="ordenDetalles" @click="imprimirDetalles" class="w-full sm:w-auto px-4 sm:px-5 py-1.5 bg-blue-600 text-white rounded-lg text-[9px] sm:text-[10px] font-black uppercase shadow-md hover:bg-blue-700 transition-all flex items-center justify-center gap-2">
              <Icon icon="mdi:printer" width="14" height="14" />
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue';
import { obtenerPagosSalidaEquipo } from '@/api/pagoSalidaEquipo';
import { obtenerClientes } from '@/api/clientes';
import { descargarReportePagosPDF } from '@/utils/reportePagosGenerator';
import { 
  obtenerRecepcionConRelaciones, 
  obtenerRecepciones 
} from '@/api/recepcionEquipo';

const STORAGE_KEY = 'fechaSeleccionada';
const STORAGE_VISTA = 'vistaPagosSeleccionada';

// ⭐ CACHE GLOBAL
const CACHE = {
  clientes: null,
  clientesMap: null,
  clientesTimestamp: 0,
  recepciones: null,
  recepcionesTimestamp: 0,
  ordenesCompletas: new Map(),
  ordenesEnVuelo: new Map()
};

const TTL_CLIENTES = 10 * 60 * 1000;
const TTL_RECEPCIONES = 2 * 60 * 1000;

function withTimeout(promise, ms = 8000) {
  return Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), ms))
  ]);
}

// ⭐ Helpers de fecha
const toISODate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

const parseISODate = (s) => {
  if (!s) return new Date();
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
};

const inicioSemana = (fecha) => {
  const d = new Date(fecha);
  const day = d.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + diff);
  d.setHours(0, 0, 0, 0);
  return d;
};

const finSemana = (fecha) => {
  const ini = inicioSemana(fecha);
  const fin = new Date(ini);
  fin.setDate(fin.getDate() + 6);
  fin.setHours(23, 59, 59, 999);
  return fin;
};

export default {
  name: 'PagoServicio',
  components: { Icon },
  data() {
    return {
      loading: false,
      pagos: [],
      clientes: [],
      clientesMap: {},
      
      vistaActual: 'dia',
      
      fechaInput: toISODate(new Date()),
      fechaMaxima: toISODate(new Date()),
      
      rangoDesde: toISODate(new Date()),
      rangoHasta: toISODate(new Date()),
      
      filters: {
        numeroOrden: '',
        cliente: '',
        metodoPago: '',
        tipoCredito: ''
      },
      pagination: {
        currentPage: 1,
        perPage: 15,
        total: 0,
        lastPage: 1
      },
      showModal: false,
      ordenDetalles: null,
      loadingDetalles: false,
      tabActiva: 'resumen',
      _requestId: 0
    };
  },
  computed: {
    vistasDisponibles() {
      return [
        { key: 'dia', label: 'Día', icon: 'mdi:calendar-today' },
        { key: 'semana', label: 'Semana', icon: 'mdi:calendar-week' },
        { key: 'mes', label: 'Mes', icon: 'mdi:calendar-month' },
        { key: 'rango', label: 'Rango', icon: 'mdi:calendar-range' }
      ];
    },

    tabsDisponibles() {
      return [
        { key: 'resumen', label: 'resumen' },
        { key: 'equipo', label: 'equipo' },
        { key: 'servicios', label: 'servicios' },
        { key: 'pagos', label: 'pagos' },
        { key: 'observaciones', label: 'obs.' }
      ];
    },

    tituloPeriodo() {
      if (this.vistaActual === 'dia') return this.fechaActual;
      if (this.vistaActual === 'semana') return `Semana del ${this.etiquetaSemana}`;
      if (this.vistaActual === 'mes') return this.etiquetaMes;
      if (this.vistaActual === 'rango') return `Del ${this.formatoFechaCorta(this.rangoDesde)} al ${this.formatoFechaCorta(this.rangoHasta)}`;
      return '';
    },

    etiquetaSemana() {
      const base = parseISODate(this.fechaInput);
      const ini = inicioSemana(base);
      const fin = finSemana(base);
      const mismoMes = ini.getMonth() === fin.getMonth();
      const mismoAnio = ini.getFullYear() === fin.getFullYear();

      const diaIni = ini.getDate();
      const diaFin = fin.getDate();
      const mesIni = ini.toLocaleDateString('es-ES', { month: 'long' });
      const mesFin = fin.toLocaleDateString('es-ES', { month: 'long' });
      const anio = fin.getFullYear();

      if (mismoMes && mismoAnio) return `${diaIni} al ${diaFin} de ${mesIni} ${anio}`;
      if (mismoAnio) return `${diaIni} de ${mesIni} al ${diaFin} de ${mesFin} ${anio}`;
      return `${diaIni} de ${mesIni} ${ini.getFullYear()} al ${diaFin} de ${mesFin} ${anio}`;
    },

    etiquetaMes() {
      const base = parseISODate(this.fechaInput);
      return base.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });
    },

    fechaActual() {
      if (!this.fechaInput) return '';
      const d = parseISODate(this.fechaInput);
      return d.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    },
    
    esFechaHoy() {
      return this.fechaInput === toISODate(new Date());
    },

    rangoFechas() {
      if (this.vistaActual === 'dia') {
        const d = parseISODate(this.fechaInput);
        return { desde: d, hasta: new Date(d.getTime() + 86399999) };
      }
      if (this.vistaActual === 'semana') {
        const base = parseISODate(this.fechaInput);
        return { desde: inicioSemana(base), hasta: finSemana(base) };
      }
      if (this.vistaActual === 'mes') {
        const base = parseISODate(this.fechaInput);
        const ini = new Date(base.getFullYear(), base.getMonth(), 1, 0, 0, 0, 0);
        const fin = new Date(base.getFullYear(), base.getMonth() + 1, 0, 23, 59, 59, 999);
        return { desde: ini, hasta: fin };
      }
      if (this.vistaActual === 'rango') {
        return {
          desde: parseISODate(this.rangoDesde),
          hasta: (() => {
            const h = parseISODate(this.rangoHasta);
            h.setHours(23, 59, 59, 999);
            return h;
          })()
        };
      }
      return null;
    },
    
    pagosEnriquecidos() {
      return this.pagos.map(pago => {
        let cliente = null;
        if (pago.idCliente) cliente = this.clientesMap[pago.idCliente];
        if (!cliente && pago.nombreCliente) {
          cliente = this.clientes.find(c => {
            const nc = `${c.nombre || ''} ${c.apellido || ''}`.trim();
            return nc.toLowerCase().includes(pago.nombreCliente.toLowerCase());
          });
        }
        return {
          ...pago,
          nombreCliente: cliente ? `${cliente.nombre || ''} ${cliente.apellido || ''}`.trim() : pago.nombreCliente || 'Sin cliente',
          documentoCliente: cliente?.documento || null,
          telefonoCliente: cliente?.telefono || null,
          emailCliente: cliente?.email || null
        };
      });
    },
    
    pagosBase() {
      return this.pagosEnriquecidos.filter(pago => {
        const montoUsd = Number(pago.montoUsd) || 0;
        const metodoPago = pago.metodoPago || '';
        if (montoUsd <= 0) return metodoPago === 'CREDITO EMPRESA' || metodoPago === 'CREDITO EMPRESARIAL';
        return true;
      });
    },
    
    pagosPorVista() {
      const rango = this.rangoFechas;
      if (!rango) return this.pagosBase;

      return this.pagosBase.filter(pago => {
        if (!pago.fechaPago) return false;
        const fechaPago = new Date(pago.fechaPago);
        return fechaPago >= rango.desde && fechaPago <= rango.hasta;
      });
    },
    
    totalMontoFiltrado() {
      return this.pagosFiltrados.reduce((sum, p) => sum + (p.montoUsd || 0), 0);
    },
    
    totalMontoBsFiltrado() {
      return this.pagosFiltrados.reduce((sum, p) => sum + (p.montoBs || 0), 0);
    },
    
    pagosFiltrados() {
      const pagos = this.pagosPorVista.filter(pago => {
        if (this.filters.numeroOrden && !pago.numeroOrden?.toLowerCase().includes(this.filters.numeroOrden.toLowerCase())) return false;
        if (this.filters.cliente && !pago.nombreCliente?.toLowerCase().includes(this.filters.cliente.toLowerCase())) return false;
        if (this.filters.metodoPago && pago.metodoPago !== this.filters.metodoPago) return false;
        if (this.filters.tipoCredito) {
          const tc = (pago.tipoCredito || '').toUpperCase().trim();
          const tcNorm = tc === 'EMPRESARIAL' ? 'EMPRESA' : tc;
          if (tcNorm !== this.filters.tipoCredito) return false;
        }
        return true;
      });
      const start = (this.pagination.currentPage - 1) * this.pagination.perPage;
      return pagos.slice(start, start + this.pagination.perPage);
    },

    // ⭐ Items del detalle (servicios/productos)
    itemsDetalle() {
      if (!this.ordenDetalles) return [];
      const detalles = this.ordenDetalles.recepcionEquipoDetalles 
                    || this.ordenDetalles.detalles 
                    || [];
      if (!Array.isArray(detalles) || detalles.length === 0) return [];
      
      return detalles.map(det => {
        const cantidad = det.cantidad || det.Cantidad || 1;
        const subtotal = parseFloat(det.subtotalUsd || det.SubtotalUsd || det.precioUnitarioUsd || det.PrecioUnitarioUsd || 0);
        const precioUnit = subtotal / (cantidad || 1);
        
        const idServicio = det.idServicio || det.IdServicio;
        const idProducto = det.idProducto || det.IdProducto;
        const nombreServicio = det.nombreServicio || det.NombreServicio || det.servicio?.nombre || '';
        const nombreProducto = det.nombreProducto || det.NombreProducto || det.producto?.nombre || '';
        const obs = det.observaciones || det.Observaciones || '';
        const uuid = (det.idRecepcionEquipoDetalle || det.IdRecepcionEquipoDetalle || Math.random()).toString();
        
        if (obs.toUpperCase().startsWith('REPUESTO:')) {
          return { uuid, tipo: 'repuesto', nombre: obs.replace(/^REPUESTO:\s*/i, '').trim(), precio_unitario: subtotal, precio_total: subtotal, cantidad: 1 };
        }
        if (idServicio) return { uuid, tipo: 'servicio', nombre: obs || nombreServicio || 'Servicio Técnico', precio_unitario: precioUnit, precio_total: subtotal, cantidad };
        if (idProducto) return { uuid, tipo: 'producto', nombre: obs || nombreProducto || 'Producto', precio_unitario: precioUnit, precio_total: subtotal, cantidad };
        if (subtotal > 0) return { uuid, tipo: 'servicio', nombre: obs || 'Servicio Técnico', precio_unitario: precioUnit, precio_total: subtotal, cantidad };
        return null;
      }).filter(Boolean);
    },

    totalGeneralDetalle() {
      return this.itemsDetalle.reduce((sum, it) => sum + (parseFloat(it.precio_total) || 0), 0);
    },

    pagosDetalle() {
      if (!this.ordenDetalles) return [];
      const pagos = this.ordenDetalles.pagos || this.ordenDetalles.Pagos || [];
      if (!Array.isArray(pagos)) return [];
      if (pagos.length === 0 && this.ordenDetalles.montoPagado > 0) {
        return [{
          montoUsd: this.ordenDetalles.montoPagado || 0,
          montoBs: this.ordenDetalles.montoBs || 0,
          fechaPago: this.ordenDetalles.fechaPago || this.ordenDetalles.fechaRegistro,
          metodoPago: this.ordenDetalles.metodoPago || 'Efectivo',
          referencia: this.ordenDetalles.referenciaPago || this.ordenDetalles.referencia,
          usuarioRegistro: this.ordenDetalles.usuarioRegistro
        }];
      }
      return pagos;
    },

    totalPagadoDetalle() {
      return this.pagosDetalle.reduce((sum, p) => sum + (parseFloat(p.montoUsd) || 0), 0);
    }
  },
  watch: {
    pagosPorVista() { this.actualizarPaginacion(); },
    fechaInput(nuevaFecha) {
      if (nuevaFecha) {
        localStorage.setItem(STORAGE_KEY, nuevaFecha);
        if (this.$route.query.fecha !== nuevaFecha) {
          this.$router.replace({ query: { ...this.$route.query, fecha: nuevaFecha } }).catch(() => {});
        }
      }
    },
    vistaActual(nuevaVista) {
      if (nuevaVista) localStorage.setItem(STORAGE_VISTA, nuevaVista);
    }
  },
  async mounted() {
    const hoy = toISODate(new Date());
    this.fechaMaxima = hoy;

    const fechaUrl = this.$route.query.fecha;
    const fechaStorage = localStorage.getItem(STORAGE_KEY);
    const vistaStorage = localStorage.getItem(STORAGE_VISTA);
    
    if (fechaUrl && /^\d{4}-\d{2}-\d{2}$/.test(fechaUrl)) this.fechaInput = fechaUrl;
    else if (fechaStorage && /^\d{4}-\d{2}-\d{2}$/.test(fechaStorage)) this.fechaInput = fechaStorage;
    else this.fechaInput = hoy;

    if (vistaStorage && ['dia', 'semana', 'mes', 'rango'].includes(vistaStorage)) {
      this.vistaActual = vistaStorage;
    }

    const base = parseISODate(this.fechaInput);
    this.rangoDesde = toISODate(inicioSemana(base));
    this.rangoHasta = toISODate(finSemana(base));
    
    this.cargarClientesDesdeCache();
    await this.recargarPagos();
  },
  methods: {
    // ═══════════════════════════════════════════
    // CALENDARIO
    // ═══════════════════════════════════════════
    cambiarVista(vista) {
      if (vista === this.vistaActual) return;
      this.vistaActual = vista;
      this.pagination.currentPage = 1;
      if (vista === 'rango' && (!this.rangoDesde || !this.rangoHasta)) {
        const base = parseISODate(this.fechaInput);
        this.rangoDesde = toISODate(new Date(base.getFullYear(), base.getMonth(), 1));
        this.rangoHasta = toISODate(new Date(base.getFullYear(), base.getMonth() + 1, 0));
      }
      this.actualizarPaginacion();
    },

    navegar(delta) {
      const base = parseISODate(this.fechaInput);
      if (this.vistaActual === 'dia') {
        base.setDate(base.getDate() + delta);
      } else if (this.vistaActual === 'semana') {
        base.setDate(base.getDate() + delta * 7);
      } else if (this.vistaActual === 'mes') {
        base.setMonth(base.getMonth() + delta);
      } else if (this.vistaActual === 'rango') {
        const ini = parseISODate(this.rangoDesde);
        const fin = parseISODate(this.rangoHasta);
        const dias = Math.round((fin - ini) / 86400000) + 1;
        ini.setDate(ini.getDate() + delta * dias);
        fin.setDate(fin.getDate() + delta * dias);
        const hoy = new Date();
        if (fin > hoy) {
          const diff = Math.ceil((fin - hoy) / 86400000);
          ini.setDate(ini.getDate() - diff);
          fin.setDate(fin.getDate() - diff);
        }
        this.rangoDesde = toISODate(ini);
        this.rangoHasta = toISODate(fin);
        this.pagination.currentPage = 1;
        return;
      }
      
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      if (base > hoy) base.setTime(hoy.getTime());
      
      this.fechaInput = toISODate(base);
      this.pagination.currentPage = 1;
    },

    resetearPeriodo() {
      const hoy = new Date();
      this.fechaInput = toISODate(hoy);
      
      if (this.vistaActual === 'rango') {
        this.rangoDesde = toISODate(new Date(hoy.getFullYear(), hoy.getMonth(), 1));
        this.rangoHasta = toISODate(hoy);
      }
      this.pagination.currentPage = 1;
    },

    validarRango() {
      if (!this.rangoDesde || !this.rangoHasta) return;
      if (this.rangoDesde > this.rangoHasta) {
        this.rangoHasta = this.rangoDesde;
      }
      this.pagination.currentPage = 1;
    },
    setRangoUltimos7Dias() {
      const hoy = new Date();
      const ini = new Date(hoy);
      ini.setDate(ini.getDate() - 6);
      this.rangoDesde = toISODate(ini);
      this.rangoHasta = toISODate(hoy);
      this.pagination.currentPage = 1;
    },
    setRangoUltimos30Dias() {
      const hoy = new Date();
      const ini = new Date(hoy);
      ini.setDate(ini.getDate() - 29);
      this.rangoDesde = toISODate(ini);
      this.rangoHasta = toISODate(hoy);
      this.pagination.currentPage = 1;
    },

    formatoFechaCorta(iso) {
      if (!iso) return '';
      const d = parseISODate(iso);
      return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
    },

    // ═══════════════════════════════════════════
    // CARGA DE DATOS CON CACHE
    // ═══════════════════════════════════════════
    async cargarClientesDesdeCache(force = false) {
      const ahora = Date.now();
      const cacheValido = !force && CACHE.clientes && (ahora - CACHE.clientesTimestamp) < TTL_CLIENTES;
      
      if (cacheValido) {
        this.clientes = CACHE.clientes;
        this.clientesMap = CACHE.clientesMap;
        return;
      }
      
      if (CACHE._clientesPromise) {
        await CACHE._clientesPromise;
        this.clientes = CACHE.clientes || [];
        this.clientesMap = CACHE.clientesMap || {};
        return;
      }
      
      CACHE._clientesPromise = (async () => {
        try {
          const res = await withTimeout(obtenerClientes(), 10000);
          if (res.success) {
            CACHE.clientes = res.data || [];
            CACHE.clientesMap = {};
            CACHE.clientes.forEach(c => { CACHE.clientesMap[c.idCliente] = c; });
            CACHE.clientesTimestamp = Date.now();
          }
        } catch (e) {
          console.warn('⚠️ Error cargando clientes:', e);
          if (!CACHE.clientes) {
            CACHE.clientes = [];
            CACHE.clientesMap = {};
          }
        } finally {
          CACHE._clientesPromise = null;
        }
      })();
      
      await CACHE._clientesPromise;
      this.clientes = CACHE.clientes || [];
      this.clientesMap = CACHE.clientesMap || {};
    },

    async cargarRecepcionesDesdeCache(force = false) {
      const ahora = Date.now();
      const cacheValido = !force && CACHE.recepciones && (ahora - CACHE.recepcionesTimestamp) < TTL_RECEPCIONES;
      
      if (cacheValido) return CACHE.recepciones;
      
      if (CACHE._recepcionesPromise) {
        return await CACHE._recepcionesPromise;
      }
      
      CACHE._recepcionesPromise = (async () => {
        try {
          const res = await withTimeout(obtenerRecepciones(), 10000);
          if (res.success) {
            CACHE.recepciones = res.data || [];
            CACHE.recepcionesTimestamp = Date.now();
            return CACHE.recepciones;
          }
          return [];
        } catch (e) {
          console.warn('⚠️ Error cargando recepciones:', e);
          return CACHE.recepciones || [];
        } finally {
          CACHE._recepcionesPromise = null;
        }
      })();
      
      return await CACHE._recepcionesPromise;
    },

    async cargarOrdenCompleta(idRecepcionEquipo, pagoFallback) {
      const key = String(idRecepcionEquipo);
      
      if (CACHE.ordenesCompletas.has(key)) {
        console.log('⚡ Orden desde cache:', key);
        return CACHE.ordenesCompletas.get(key);
      }
      
      if (CACHE.ordenesEnVuelo.has(key)) {
        console.log('⏳ Esperando petición en vuelo:', key);
        return await CACHE.ordenesEnVuelo.get(key);
      }
      
      const promesa = (async () => {
        try {
          const [relRes, pagosRes] = await Promise.allSettled([
            withTimeout(obtenerRecepcionConRelaciones(idRecepcionEquipo), 8000),
            (async () => {
              try {
                const { apiFetch } = await import('@/api/index.js');
                return await withTimeout(apiFetch(`/PagoSalidaEquipo/porRecepcion/${idRecepcionEquipo}`), 6000);
              } catch { return []; }
            })()
          ]);
          
          let ordenData = null;
          if (relRes.status === 'fulfilled' && relRes.value?.success) {
            ordenData = relRes.value.data;
          }
          
          let pagosData = [];
          if (pagosRes.status === 'fulfilled' && Array.isArray(pagosRes.value)) {
            pagosData = pagosRes.value;
          }
          
          if (pagosData.length === 0 && pagoFallback) {
            pagosData = [{
              montoUsd: pagoFallback.montoUsd || 0,
              montoBs: pagoFallback.montoBs || 0,
              fechaPago: pagoFallback.fechaPago,
              metodoPago: pagoFallback.metodoPago,
              referencia: pagoFallback.referencia,
              tipoPago: pagoFallback.tipoPago,
              usuarioRegistro: pagoFallback.usuarioRegistro || pagoFallback.usuarioCreacion
            }];
          }
          
          if (!ordenData) {
            return this.construirFallback(pagoFallback);
          }
          
          if (ordenData.detalles && !ordenData.recepcionEquipoDetalles) {
            ordenData.recepcionEquipoDetalles = ordenData.detalles;
          }
          
          if (!ordenData.recepcionEquipoDetalles && !ordenData.detalles) {
            try {
              const { apiFetch } = await import('@/api/index.js');
              const detallesRes = await withTimeout(apiFetch(`/RecepcionEquipo/${idRecepcionEquipo}/detalles`), 5000);
              if (Array.isArray(detallesRes) && detallesRes.length > 0) {
                ordenData.recepcionEquipoDetalles = detallesRes;
              }
            } catch { /* ignore */ }
          }
          
          if (ordenData.idCliente && this.clientesMap[ordenData.idCliente]) {
            ordenData.cliente = this.clientesMap[ordenData.idCliente];
          } else if (pagoFallback?.nombreCliente) {
            ordenData.cliente = {
              nombre: pagoFallback.nombreCliente,
              documento: pagoFallback.documentoCliente || 'N/A',
              telefono: pagoFallback.telefonoCliente || 'N/A',
              email: pagoFallback.emailCliente || 'N/A'
            };
          }
          
          const actividades = this.parseActividades(ordenData.actividadesRealizadas || pagoFallback?.actividadesRealizadas);
          
          const ordenMapeada = {
            numeroOrden: ordenData.numeroOrden || pagoFallback?.numeroOrden,
            estado: ordenData.nombreEstado || pagoFallback?.estado || 'Desconocido',
            fechaIngreso: ordenData.fechaIngreso || pagoFallback?.fechaIngreso || pagoFallback?.fechaPago,
            fechaEntrega: ordenData.fechaEntrega || pagoFallback?.fechaEntrega || null,
            equipo: ordenData.nombreProductoServicio || pagoFallback?.nombreProductoServicio || pagoFallback?.equipo || 'No disponible',
            descripcionEquipo: ordenData.descripcion || pagoFallback?.descripcion || 'No disponible',
            accesorios: ordenData.accesorios || pagoFallback?.accesorios || 'No especificado',
            clavePatron: ordenData.clavePatron || pagoFallback?.clavePatron || 'No especificado',
            problema: ordenData.problema || pagoFallback?.problema || 'No especificado',
            diagnostico: actividades.diagnostico,
            solucion: actividades.solucion,
            cliente: ordenData.cliente || {
              nombre: pagoFallback?.nombreCliente || 'Sin cliente',
              documento: pagoFallback?.documentoCliente || 'N/A',
              telefono: pagoFallback?.telefonoCliente || 'N/A',
              email: pagoFallback?.emailCliente || 'N/A'
            },
            montoDolares: ordenData.precioTotalUsd || pagoFallback?.precioTotalUsd || pagoFallback?.montoUsd || 0,
            montoBolivares: pagoFallback?.montoBs || 0,
            tasa: { valor: pagoFallback?.tasaBsUsd || 'N/A' },
            sede: ordenData.nombreSede || ordenData.taller || pagoFallback?.nombreSede || pagoFallback?.taller || 'N/A',
            tecnicoRecepcion: ordenData.nombreTecnicoRecepcion || pagoFallback?.nombreTecnicoRecepcion || 'N/A',
            tecnicoReparador: ordenData.nombreTecnicoReparador || pagoFallback?.nombreTecnicoReparador || 'N/A',
            idRecepcionEquipo: idRecepcionEquipo,
            idCliente: ordenData.idCliente || pagoFallback?.idCliente,
            fechaRegistro: pagoFallback?.fechaRegistro || pagoFallback?.createdAt || pagoFallback?.fechaPago,
            usuarioRegistro: pagoFallback?.usuarioRegistro || pagoFallback?.usuarioCreacion || pagoFallback?.registradoPor || 'N/A',
            fechaModificacion: pagoFallback?.fechaModificacion || null,
            usuarioModificacion: pagoFallback?.usuarioModificacion || null,
            observaciones: ordenData.observaciones || pagoFallback?.observaciones || null,
            recepcionEquipoDetalles: ordenData.recepcionEquipoDetalles || ordenData.detalles || [],
            detalles: ordenData.detalles || ordenData.recepcionEquipoDetalles || [],
            pagos: pagosData
          };
          
          CACHE.ordenesCompletas.set(key, ordenMapeada);
          return ordenMapeada;
        } finally {
          CACHE.ordenesEnVuelo.delete(key);
        }
      })();
      
      CACHE.ordenesEnVuelo.set(key, promesa);
      return await promesa;
    },

    cambiarFechaDesdeInput() {
      if (this.fechaInput) {
        const hoy = toISODate(new Date());
        if (this.fechaInput > hoy) this.fechaInput = hoy;
      }
    },

    async recargarPagos() {
      this.loading = true;
      try {
        const [pagosRes] = await Promise.all([
          withTimeout(obtenerPagosSalidaEquipo(), 10000),
          this.cargarClientesDesdeCache()
        ]);

        if (!pagosRes.success) throw new Error(pagosRes.error);

        this.pagos = (pagosRes.data || []).sort((a, b) => new Date(b.fechaPago) - new Date(a.fechaPago));
        this.actualizarPaginacion();
        this.precargarOrdenesVisibles();

      } catch (error) {
        console.error('Error buscando pagos:', error);
        this.$toast?.error(error.message || 'Error al cargar los pagos');
        this.pagos = [];
      } finally {
        this.loading = false;
      }
    },

    precargarOrdenesVisibles() {
      setTimeout(() => {
        const primeros = this.pagosFiltrados.slice(0, 5);
        primeros.forEach((pago, index) => {
          setTimeout(() => {
            if (pago.idRecepcionEquipo) {
              this.cargarOrdenCompleta(pago.idRecepcionEquipo, pago).catch(() => {});
            } else if (pago.numeroOrden) {
              this.resolverYPrecargar(pago).catch(() => {});
            }
          }, index * 200);
        });
      }, 100);
    },

    async resolverYPrecargar(pago) {
      try {
        const recepciones = await this.cargarRecepcionesDesdeCache();
        const orden = recepciones.find(r => String(r.numeroOrden) === String(pago.numeroOrden));
        if (orden) {
          const idRec = orden.idRecepcionEquipo || orden.id;
          if (idRec) {
            await this.cargarOrdenCompleta(idRec, pago);
          }
        }
      } catch { /* ignore */ }
    },

    actualizarPaginacion() {
      const total = this.pagosPorVista.length;
      this.pagination.total = total;
      this.pagination.lastPage = Math.ceil(total / this.pagination.perPage) || 1;
      if (this.pagination.currentPage > this.pagination.lastPage) {
        this.pagination.currentPage = this.pagination.lastPage || 1;
      }
    },

    filtrarPagos() {
      this.pagination.currentPage = 1;
      this.actualizarPaginacion();
    },

    limpiarFiltros() {
      this.filters = { numeroOrden: '', cliente: '', metodoPago: '', tipoCredito: '' };
      this.pagination.currentPage = 1;
      this.actualizarPaginacion();
    },

    cambiarPagina(page) {
      if (page < 1 || page > this.pagination.lastPage) return;
      this.pagination.currentPage = page;
      setTimeout(() => this.precargarOrdenesVisibles(), 100);
    },

    async descargarReporte() {
      if (this.pagosFiltrados.length === 0) {
        this.$toast?.warning('No hay pagos para generar el reporte');
        return;
      }
      try {
        await descargarReportePagosPDF(this.pagosFiltrados, {
          vista: this.vistaActual,
          fecha: this.fechaInput,
          desde: this.rangoDesde,
          hasta: this.rangoHasta,
          numeroOrden: this.filters.numeroOrden,
          cliente: this.filters.cliente,
          metodoPago: this.filters.metodoPago,
          tipoCredito: this.filters.tipoCredito
        });
        this.$toast?.success('Reporte PDF generado exitosamente');
      } catch (error) {
        console.error('Error al descargar reporte:', error);
        this.$toast?.error('Error al generar el reporte PDF');
      }
    },

    parseActividades(texto) {
      if (!texto) return { diagnostico: 'No especificado', solucion: 'No especificado' };
      const diagMatch = texto.match(/DIAGN[ÓO]STICO[^:]*:([\s\S]*?)(?:SOLUCI[ÓO]N:|$)/i);
      const solMatch = texto.match(/SOLUCI[ÓO]N:([\s\S]*?)(?:Entrega Orden|$)/i);
      return {
        diagnostico: diagMatch && diagMatch[1].trim() ? diagMatch[1].trim() : 'No especificado',
        solucion: solMatch && solMatch[1].trim() ? solMatch[1].trim() : 'No especificado'
      };
    },

    construirFallback(pago) {
      if (!pago) return null;
      const actividades = this.parseActividades(pago.actividadesRealizadas);
      return {
        numeroOrden: pago.numeroOrden || 'N/A',
        estado: pago.nombreEstado || pago.estado || 'Desconocido',
        fechaIngreso: pago.fechaIngreso || pago.fechaPago,
        fechaEntrega: pago.fechaEntrega || null,
        equipo: pago.nombreProductoServicio || pago.equipo || 'No disponible',
        descripcionEquipo: pago.descripcion || 'No disponible',
        accesorios: pago.accesorios || 'No especificado',
        clavePatron: pago.clavePatron || 'No especificado',
        problema: pago.problema || 'No especificado',
        diagnostico: actividades.diagnostico,
        solucion: actividades.solucion,
        cliente: {
          nombre: pago.nombreCliente || 'Sin cliente',
          documento: pago.documentoCliente || 'N/A',
          telefono: pago.telefonoCliente || 'N/A',
          email: pago.emailCliente || 'N/A'
        },
        montoDolares: pago.precioTotalUsd || pago.montoUsd || 0,
        montoBolivares: pago.montoBs || 0,
        tasa: { valor: pago.tasaBsUsd || 'N/A' },
        sede: pago.nombreSede || pago.taller || 'N/A',
        tecnicoRecepcion: pago.nombreTecnicoRecepcion || 'N/A',
        tecnicoReparador: pago.nombreTecnicoReparador || 'N/A',
        fechaRegistro: pago.fechaRegistro || pago.createdAt || pago.fechaPago,
        usuarioRegistro: pago.usuarioRegistro || pago.usuarioCreacion || pago.registradoPor || 'N/A',
        observaciones: pago.observaciones || null,
        recepcionEquipoDetalles: pago.recepcionEquipoDetalles || pago.detalles || [],
        pagos: [{
          montoUsd: pago.montoUsd || 0,
          montoBs: pago.montoBs || 0,
          fechaPago: pago.fechaPago,
          metodoPago: pago.metodoPago,
          referencia: pago.referencia,
          tipoPago: pago.tipoPago,
          usuarioRegistro: pago.usuarioRegistro || pago.usuarioCreacion
        }]
      };
    },

    // ⭐ ABRIR MODAL DE DETALLES
    async verDetallesEquipo(pago) {
      if (!pago) {
        this.$toast?.error('Error: Datos del pago no disponibles');
        return;
      }

      this._requestId++;
      const currentRequest = this._requestId;

      this.showModal = true;
      this.tabActiva = 'resumen';

      let idRec = pago.idRecepcionEquipo;
      
      if (!idRec && pago.numeroOrden) {
        try {
          const recepciones = await this.cargarRecepcionesDesdeCache();
          const orden = recepciones.find(r => String(r.numeroOrden) === String(pago.numeroOrden));
          if (orden) idRec = orden.idRecepcionEquipo || orden.id;
        } catch { /* ignore */ }
      }

      if (idRec && CACHE.ordenesCompletas.has(String(idRec))) {
        console.log('⚡ Mostrando desde cache inmediato');
        this.ordenDetalles = CACHE.ordenesCompletas.get(String(idRec));
        this.loadingDetalles = false;
        return;
      }

      this.ordenDetalles = this.construirFallback(pago);
      this.loadingDetalles = false;

      if (!idRec) {
        this.$toast?.info('Mostrando información disponible del pago');
        return;
      }

      try {
        const ordenCompleta = await this.cargarOrdenCompleta(idRec, pago);
        
        if (currentRequest !== this._requestId || !this.showModal) return;
        
        if (ordenCompleta) {
          this.ordenDetalles = ordenCompleta;
        }
      } catch (e) {
        if (currentRequest === this._requestId && this.showModal) {
          this.$toast?.warning('No se pudieron cargar todos los detalles');
        }
      }
    },

    cerrarModal() {
      this.showModal = false;
      this.ordenDetalles = null;
      this.tabActiva = 'resumen';
      this._requestId++;
    },

    // ⭐ IMPRIMIR DETALLES
    imprimirDetalles() {
      if (!this.ordenDetalles) return;
      
      const items = this.itemsDetalle;
      const itemsHtml = items.length > 0 
        ? items.map(it => `
            <tr>
              <td style="padding: 5px; border-bottom: 1px solid #e5e7eb;">${it.nombre} ${it.cantidad > 1 ? `(x${it.cantidad})` : ''}</td>
              <td style="padding: 5px; border-bottom: 1px solid #e5e7eb; text-align: right; font-weight: bold;">$${it.precio_total.toFixed(2)}</td>
            </tr>
          `).join('')
        : '<tr><td colspan="2" style="padding: 10px; text-align: center; color: #9ca3af;">No hay servicios ni productos registrados</td></tr>';

      const pagos = this.pagosDetalle;
      const pagosHtml = pagos.length > 0 
        ? pagos.map(p => `
            <tr>
              <td style="padding: 5px; border-bottom: 1px solid #e5e7eb;">${p.metodoPago || p.tipoPago || 'Efectivo'}</td>
              <td style="padding: 5px; border-bottom: 1px solid #e5e7eb;">${this.formatoFecha(p.fechaPago, true)}</td>
              <td style="padding: 5px; border-bottom: 1px solid #e5e7eb; text-align: right; font-weight: bold; color: #059669;">$${(p.montoUsd || 0).toFixed(2)}</td>
            </tr>
          `).join('')
        : '<tr><td colspan="3" style="padding: 10px; text-align: center; color: #9ca3af;">Sin pagos registrados</td></tr>';

      const contenido = document.createElement('div');
      contenido.innerHTML = `
        <div style="font-family: Arial, sans-serif; padding: 20px; max-width: 800px; margin: 0 auto;">
          <h1 style="text-align: center; color: #1a56db; border-bottom: 2px solid #1a56db; padding-bottom: 10px;">
            Detalles del Equipo - Orden #${this.ordenDetalles.numeroOrden}
          </h1>
          <div style="margin: 20px 0;">
            <h2 style="color: #374151;">Información General</h2>
            <table style="width: 100%; border-collapse: collapse;">
              <tr><td style="padding: 5px; font-weight: bold;">Cliente:</td><td>${this.ordenDetalles.cliente?.nombre || 'Sin cliente'}</td></tr>
              <tr><td style="padding: 5px; font-weight: bold;">Equipo:</td><td>${this.ordenDetalles.equipo || 'N/A'}</td></tr>
              <tr><td style="padding: 5px; font-weight: bold;">Estado:</td><td>${this.ordenDetalles.estado || 'N/A'}</td></tr>
              <tr><td style="padding: 5px; font-weight: bold;">Problema:</td><td>${this.ordenDetalles.problema || 'N/A'}</td></tr>
              <tr><td style="padding: 5px; font-weight: bold;">Diagnóstico:</td><td>${this.ordenDetalles.diagnostico || 'N/A'}</td></tr>
              <tr><td style="padding: 5px; font-weight: bold;">Solución:</td><td>${this.ordenDetalles.solucion || 'N/A'}</td></tr>
            </table>
          </div>
          <div style="margin: 20px 0;">
            <h2 style="color: #374151;">Servicios y Productos Cobrados</h2>
            <table style="width: 100%; border-collapse: collapse;">
              <thead>
                <tr style="background: #f3f4f6;">
                  <th style="padding: 5px; text-align: left; border-bottom: 2px solid #374151;">Descripción</th>
                  <th style="padding: 5px; text-align: right; border-bottom: 2px solid #374151;">Total USD</th>
                </tr>
              </thead>
              <tbody>${itemsHtml}</tbody>
              <tfoot>
                <tr style="background: #ecfdf5;">
                  <td style="padding: 8px; font-weight: bold; text-align: right; border-top: 2px solid #10b981;">TOTAL GENERAL:</td>
                  <td style="padding: 8px; font-weight: bold; text-align: right; color: #059669; border-top: 2px solid #10b981;">$${this.totalGeneralDetalle.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div style="margin: 20px 0;">
            <h2 style="color: #374151;">Pagos Registrados</h2>
            <table style="width: 100%; border-collapse: collapse;">
              <thead>
                <tr style="background: #f3f4f6;">
                  <th style="padding: 5px; text-align: left; border-bottom: 2px solid #374151;">Método</th>
                  <th style="padding: 5px; text-align: left; border-bottom: 2px solid #374151;">Fecha</th>
                  <th style="padding: 5px; text-align: right; border-bottom: 2px solid #374151;">Monto USD</th>
                </tr>
              </thead>
              <tbody>${pagosHtml}</tbody>
              <tfoot>
                <tr style="background: #ecfdf5;">
                  <td colspan="2" style="padding: 8px; font-weight: bold; text-align: right; border-top: 2px solid #10b981;">TOTAL COBRADO:</td>
                  <td style="padding: 8px; font-weight: bold; text-align: right; color: #059669; border-top: 2px solid #10b981;">$${this.totalPagadoDetalle.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div style="margin-top: 30px; border-top: 2px solid #1a56db; padding-top: 20px; text-align: center; color: #6b7280; font-size: 12px;">
            Reporte generado el ${new Date().toLocaleString()}
          </div>
        </div>
      `;

      const ventana = window.open('', '_blank', 'width=800,height=600');
      ventana.document.write(contenido.innerHTML);
      ventana.document.close();
      ventana.print();
    },

    // ═══════════════════════════════════════════
    // FORMATOS
    // ═══════════════════════════════════════════
    formatoFecha(fecha, incluirHora = false) {
      if (!fecha) return '';
      const d = new Date(fecha);
      if (isNaN(d.getTime())) return '';
      const fechaStr = d.toLocaleDateString('es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' });
      if (!incluirHora) return fechaStr;
      let horas = d.getHours();
      const minutos = String(d.getMinutes()).padStart(2, '0');
      const ampm = horas >= 12 ? 'PM' : 'AM';
      horas = horas % 12 || 12;
      return `${fechaStr}, ${horas}:${minutos} ${ampm}`;
    },

    formatFechaCompleta(fecha) {
      if (!fecha) return '—';
      const d = new Date(fecha);
      if (isNaN(d.getTime())) return '—';
      return d.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    },

    formatoMoneda(monto) {
      return new Intl.NumberFormat('es-VE', { style: 'currency', currency: 'USD' }).format(monto || 0);
    },
    
    formatoMonedaBs(monto) {
      return new Intl.NumberFormat('es-VE', { style: 'currency', currency: 'VES' }).format(monto || 0);
    },

    metodoPagoClass(metodo) {
      const classes = {
        'Efectivo': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
        'Punto de Venta': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
        'Pago Móvil': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300',
        'Transferencia': 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300',
        'Depósito': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
        'Tarjeta de Crédito': 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
        'CREDITO CACHEAS': 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
        'CREDITO EMPRESA': 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300',
        'CREDITO EMPRESARIAL': 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300'
      };
      return classes[metodo] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    },

    tipoCreditoClass(tipo) {
      const classes = {
        'CACHEAS': 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
        'EMPRESA': 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300',
        'EMPRESARIAL': 'bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300'
      };
      return classes[tipo] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    },

    tipoPagoClass(tipo) {
      const classes = {
        'Completo': 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
        'Abono': 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
        'EXPRESS': 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300'
      };
      return classes[tipo] || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    }
  }
};
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 9999px; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #475569; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #64748b; }

input[type="date"]::-webkit-calendar-picker-indicator { filter: invert(0.5); cursor: pointer; }
.dark input[type="date"]::-webkit-calendar-picker-indicator { filter: invert(0.8); }
input[type="date"]::-webkit-datetime-edit { color: inherit; }

@keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }
</style>